declare const jQuery: any;
const $ = jQuery;
type JQuery = any;

export interface DragSettings
{
	dragStart?: number; // how far el must be dragged before dragging behaviour triggered (px)
	getDropTargets?: () => JQuery;
}

export interface PositionInfo
{
	x: number; // Absolute x new position of element (px)
	y: number; // Absolute y new position of element (px)
	dx: number; // How far in px the element has been dragged horizontally
	dy: number; // How far in px the element has been dragged vertically
}

const defaultDragStart: number = 6;

let $draggedEl: JQuery = undefined;
let $dropTargets: JQuery = undefined;
let $currentDropTarget: JQuery = undefined;
let globalInitExecuted: boolean = false;
let initialElementX: number = 0;
let initialElementY: number = 0;
let initialMouseX: number = 0;
let initialMouseY: number = 0;
let draggingActivated: boolean = false;
let currentDragStart: number = 0;

export function initDraggable($draggable, dragSettings: DragSettings = {}): void
{
	const dragStart: number = (dragSettings.dragStart === undefined) ?
		defaultDragStart :
		dragSettings.dragStart;
	$draggable.on("mousedown", (e) => {
		draggingActivated = false;
		currentDragStart = dragStart;
		$draggedEl = $draggable;
		initialElementX = $draggable.position().left;
		initialElementY = $draggable.position().top;
		initialMouseX = e.pageX;
		initialMouseY = e.pageY;
		$dropTargets = dragSettings.getDropTargets ?
			dragSettings.getDropTargets() :
			undefined;
		if ($dropTargets)
		{
			$dropTargets.
				off("mouseenter", handleDropTargetMouseEnter).
				on("mouseenter", handleDropTargetMouseEnter).
				off("mouseleave", handleDropTargetMouseLeave).
				on("mouseleave", handleDropTargetMouseLeave);
		}
		$currentDropTarget = undefined;
		e.stopPropagation();
		e.preventDefault();
	});
	globalInit();
}

function handleDropTargetMouseEnter(e)
{
	if (!draggingActivated)
	{
		return;
	}
	const $this = $(this);
	if (!$this.is($dropTargets))
	{
		return;
	}
	$currentDropTarget = $this;
}

function handleDropTargetMouseLeave(e)
{
	$currentDropTarget = undefined;
}

function globalInit(): void
{
	if (globalInitExecuted)
	{
		return;
	}
	globalInitExecuted = true;
	const $body = $("body");
	const createEventData = (position: PositionInfo) => {
		return {
			position,
			$dropTarget: $currentDropTarget
		};
	};

	//fixme - deal with drag out of <body>
	$body.on("mouseup", (e) => {
		if (!draggingActivated)
		{
			cleanup();
			return;
		}
		const position = getNewElementPosition(e.pageX, e.pageY);
		$draggedEl.trigger("iw-dragend", createEventData(position));
		cleanup();
	}).on("mousemove", (e) => {
		if (!$draggedEl)
		{
			return;
		}
		const position = getNewElementPosition(e.pageX, e.pageY);
		if (draggingActivated)
		{
			$draggedEl.trigger("iw-drag", createEventData(position));
		}
		else if (draggingShouldActivate(position))
		{
			draggingActivated = true;
			$draggedEl.trigger("iw-dragstart", createEventData(position));
		}
	});
}

function draggingShouldActivate(position: PositionInfo): boolean
{
	return (position.dx >= currentDragStart) || (position.dy >= currentDragStart);
}

function getNewElementPosition(currentMouseX: number, currentMouseY: number): PositionInfo
{
	const dx: number = currentMouseX - initialMouseX;
	const dy: number = currentMouseY - initialMouseY;
	return {
		x: initialElementX + dx,
		y: initialElementY + dy,
		dx,
		dy
	};
}

function cleanup(): void
{
	if ($dropTargets)
	{
		$dropTargets.
			off("mouseenter", handleDropTargetMouseEnter).
			off("mouseleave", handleDropTargetMouseLeave);
	}
	$draggedEl = undefined;
	$dropTargets = undefined;
	$currentDropTarget = undefined;
	draggingActivated = false;
}

if (!window["iw"])
{
	window["iw"] = {};
}

window["iw"].drag = {
	initDraggable
};
